/*
 * Назначение: доверенные устройства на странице «Безопасность».
 * Функционал: список устройств, которым код входа не нужен, с датой окончания
 * доверия и кнопкой «Отозвать». Отзыв означает, что при следующем входе с этого
 * устройства снова спросят код — так закрывают доступ с потерянного ноутбука.
 */

import { Loader2, ShieldOff } from "lucide-react";

import type { TrustedDevice } from "../../../lib/security-api";
import { Button } from "../../components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";

export function TrustedDevicesCard({
  devices,
  revokingId,
  onRevoke,
}: {
  devices: TrustedDevice[];
  revokingId: string | null;
  onRevoke: (id: string) => void;
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Доверенные устройства</CardTitle>
        <CardDescription>
          На этих устройствах код при входе не запрашивается до указанной даты.
          Если устройство потеряно или им пользовался кто-то ещё — отзови доверие.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        {devices.length === 0 ? (
          <p className="py-4 text-center text-sm text-muted-foreground">
            Доверенных устройств нет — код будет спрашиваться при каждом входе.
          </p>
        ) : (
          devices.map((device) => (
            <div
              key={device.id}
              className="flex flex-col justify-between gap-2 rounded-lg border border-border p-3 md:flex-row md:items-center"
            >
              <div className="text-xs">
                <p className="text-sm">{device.label || "Устройство без подписи"}</p>
                <p className="text-muted-foreground">
                  Адрес: {device.ip ?? "неизвестен"} · доверие до{" "}
                  {new Date(device.expires_at).toLocaleDateString("ru-RU")}
                  {device.last_used_at
                    ? ` · последний вход ${new Date(device.last_used_at).toLocaleString("ru-RU")}`
                    : ""}
                </p>
              </div>
              <Button
                variant="outline"
                size="sm"
                onClick={() => onRevoke(device.id)}
                disabled={revokingId === device.id}
              >
                {revokingId === device.id ? (
                  <Loader2 className="mr-1 h-3 w-3 animate-spin" />
                ) : (
                  <ShieldOff className="mr-1 h-3 w-3" />
                )}
                Отозвать
              </Button>
            </div>
          ))
        )}
      </CardContent>
    </Card>
  );
}
